export default function() {
  const mainEl = document.querySelector('.main');
  const header = document.querySelector('.page-header--fixed');
  let lastScrollTop = 0;
  window.addEventListener('scroll', () => {
    const scrollTop =
      window.pageYOffset ||
      window.scrollY ||
      window.pageYOffset ||
      document.body.scrollTop +
        ((document.documentElement && document.documentElement.scrollTop) || 0);
    if (scrollTop >= lastScrollTop && scrollTop > 20) {
      header.classList.add('page-header--collapsed');
      mainEl.classList.add('main--header-collapsed');
    } else if (scrollTop < 180) {
      header.classList.remove('page-header--collapsed');
      mainEl.classList.remove('main--header-collapsed');
    }
    lastScrollTop = scrollTop;
  });
}
